<template>
  <div>
    <div v-if="validating" class="rounded-md bg-gray-100 p-2 mt-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <LoadingSpinner class="text-gray-400" />
        </div>
        <div class="ml-2 flex-1 md:flex md:justify-between">
          <p class="text-sm leading-5 text-gray-700">Validating Address</p>
        </div>
      </div>
    </div>

    <div v-if="validationStatus == 0" class="rounded-md bg-yellow-50 p-2 mt-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon
            set="solid"
            name="exclamation"
            class="flex-shrink-0 h-5 w-5 text-yellow-400"
          />
        </div>
        <div class="ml-2 flex-1 md:flex md:justify-between">
          <p class="text-sm leading-5 text-yellow-700">
            Shipping Address was not found.
          </p>
        </div>
        <div class="flex-shrink-0"></div>
      </div>
    </div>

    <div v-if="validationStatus > 0" class="rounded-md bg-green-50 p-2 mt-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon
            set="solid"
            name="check-circle"
            class="flex-shrink-0 h-5 w-5 text-green-400"
          />
        </div>
        <div class="ml-2 flex-1 md:flex md:justify-between">
          <p class="text-sm leading-5 text-green-700">
            Shipping Address validated.
          </p>
        </div>
      </div>
    </div>

    <div v-if="error" class="rounded-md bg-red-50 p-2 mt-2">
      <div class="flex">
        <div class="flex-shrink-0">
          <icon set="solid" name="x-circle" class="h-5 w-5 text-red-400" />
        </div>
        <div class="ml-2 flex-1 md:flex md:justify-between overflow-auto">
          <p class="text-sm leading-5 text-red-700">
            {{ errorMessage }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    validating: {
      type: Boolean,
      required: true,
      default: false,
    },
    validationStatus: {
      type: Number,
      required: true,
      default: -1,
    },
    error: {
      type: Error,
    },
  },
  data() {
    return {};
  },
  computed: {
    errorMessage() {
      return this.error?.response?.data?.message || "Something went wrong";
    },
  },
  components: {},
  methods: {},
};
</script>
